<template>
    <div class="pedigreemobile" :key="type">
        <div class="nav-bar">
            <van-nav-bar
                    right-text="选择"
                    @click-right="onClickRight"
                    title="谱系图">
            </van-nav-bar>
        </div>
        <div class="title">{{title}}</div>
        <van-divider :style="{ color: '#FFEB3B', borderColor: '#FFEB3B', padding: '16px' , fontSize:'1.0rem'}">
            总览
        </van-divider>
        <van-divider content-position="left" :style="{ color: '#8bc34a', borderColor: '#8bc34a', fontSize:'0.9rem'}">人才需求</van-divider>
        <div id="chart_allneed" style="width:100%; height:8rem;"></div>
        <van-divider content-position="left" :style="{ color: '#8bc34a', borderColor: '#8bc34a', fontSize:'0.9rem'}">人才培养</van-divider>
        <div id="chart_allprovide" style="width:100%; height:8rem;"></div>
        <van-divider content-position="left" :style="{ color: '#8bc34a', borderColor: '#8bc34a', fontSize:'0.9rem'}">产业布局</van-divider>
        <div id="chart_industrypos" style="width: 100%; height:10rem;"></div>
        <van-divider content-position="left" :style="{ color: '#8bc34a', borderColor: '#8bc34a', fontSize:'0.9rem'}">专业布局</van-divider>
        <div id="chart_majorpos" style="width: 100%; height:10rem;"></div>
        <van-divider content-position="left" :style="{ color: '#8bc34a', borderColor: '#8bc34a', fontSize:'0.9rem'}">岗位群</van-divider>
        <van-swipe :autoplay="3000">
            <van-swipe-item v-for="(pic,i) in jobpics" :key="pic">
                <img :src="`/pedigreedata/${type}/${pic}`" @click="imagePreview(jobpics, i)">
            </van-swipe-item>
        </van-swipe>
        <van-divider content-position="left" :style="{ color: '#8bc34a', borderColor: '#8bc34a', fontSize:'0.9rem'}">专业群</van-divider>
        <van-swipe :autoplay="3000">
            <van-swipe-item v-for="(pic,i) in industrypics" :key="pic">
                <img :src="`/pedigreedata/${type}/${pic}`" @click="imagePreview(industrypics, i)">
            </van-swipe-item>
        </van-swipe>
        <van-divider content-position="left" :style="{ color: '#8bc34a', borderColor: '#8bc34a', fontSize:'0.9rem'}">职业岗位能力要求</van-divider>
        <div id="chart_needkeywords" style="width: 100%; height:6rem;"></div>
        <van-divider content-position="left" :style="{ color: '#8bc34a', borderColor: '#8bc34a', fontSize:'0.9rem'}">专业能力培养要求</van-divider>
        <div id="chart_providekeywords" style="width: 100%; height:6rem;"></div>
        <div class="custom-empty"></div>
        <van-divider :style="{ color: '#FFEB3B', borderColor: '#FFEB3B', padding: '16px' , fontSize:'1.0rem'}">
            规模匹配
        </van-divider>
        <van-divider content-position="left" :style="{ color: '#8bc34a', borderColor: '#8bc34a', fontSize:'0.9rem'}">供需总缺口</van-divider>
        <div id="chart_allgap" style="width: 100%; height:8rem;"></div>
        <van-divider content-position="left" :style="{ color: '#8bc34a', borderColor: '#8bc34a', fontSize:'0.9rem'}">学历层次缺口</van-divider>
        <div id="chart_gzgap" style="width: 100%; height:8rem;"></div>
        <van-divider :style="{ color: '#FFEB3B', borderColor: '#FFEB3B', padding: '16px' , fontSize:'1.0rem'}">
            布局匹配
        </van-divider>
        <van-divider content-position="left" :style="{ color: '#8bc34a', borderColor: '#8bc34a', fontSize:'0.9rem'}">企业规模TOP10</van-divider>
        <dv-scroll-ranking-board :config="config_industrytop10" style="width:90%; height:20rem;" />
        <van-divider content-position="left" :style="{ color: '#8bc34a', borderColor: '#8bc34a', fontSize:'0.9rem'}">专业规模TOP10</van-divider>
        <dv-scroll-ranking-board :config="config_majortop10" style="width:90%; height:20rem;" />
        <van-divider :style="{ color: '#FFEB3B', borderColor: '#FFEB3B', padding: '16px' , fontSize:'0.9rem'}">
            岗位-专业匹配
        </van-divider>
        <van-divider content-position="left" :style="{ color: '#8bc34a', borderColor: '#8bc34a', fontSize:'0.9rem'}">岗位需求TOP10</van-divider>
        <dv-scroll-ranking-board :config="config_jobneedstop10" style="width:90%; height:20rem;" />
        <van-divider content-position="left" :style="{ color: '#8bc34a', borderColor: '#8bc34a', fontSize:'0.9rem'}">中职-专业供给TOP10</van-divider>
        <dv-scroll-ranking-board :config="config_jobprovidezztop5" style="width:90%; height:10rem;" />
        <van-divider content-position="left" :style="{ color: '#8bc34a', borderColor: '#8bc34a', fontSize:'0.9rem'}">高职-专业供给TOP10</van-divider>
        <dv-scroll-ranking-board :config="config_jobprovidegztop5" style="width:90%; height:10rem;" />
        <van-divider :style="{ color: '#FFEB3B', borderColor: '#FFEB3B', padding: '16px' , fontSize:'1.0rem'}">
            能力-素质匹配
        </van-divider>
        <van-divider content-position="left" :style="{ color: '#8bc34a', borderColor: '#8bc34a', fontSize:'0.9rem'}">岗位能力素质TOP</van-divider>
        <div class="tags">
            <van-tag round type="danger" v-for="(item,i) in needkeywords" :size="i<=2?'large':'medium'">{{item.name}}</van-tag>
        </div>
        <van-divider content-position="left" :style="{ color: '#8bc34a', borderColor: '#8bc34a', fontSize:'0.9rem'}">中职能力素质TOP</van-divider>
        <dv-scroll-ranking-board :config="config_keywordzz" style="width:90%; height:20rem" />
        <van-divider content-position="left" :style="{ color: '#8bc34a', borderColor: '#8bc34a', fontSize:'0.9rem'}">高职能力素质TOP</van-divider>
        <dv-scroll-ranking-board :config="config_keywordgz" style="width:90%; height:20rem" />
        <van-popup v-model="showright" position="right" :style="{ width:'70%',height: '100%' }" >
            <van-nav-bar title="选择"/>
            <van-cell-group>
                <van-cell title="电子商务" @click="goto('ds')"/>
                <van-cell title="跨境电商" @click="goto('http://62.234.87.48:8088/#/mobile/5f97c2b4fb07fe7ed613a345')"/>
                <van-cell title="大数据" @click="goto('http://62.234.87.48:8088/#/mobile/5f98d525fb07fe7ed613a346')"/>
                <van-cell title="无人机" @click="goto('wrj')"/>
                <van-cell title="工业机器人" @click="goto('jqr')"/>
                <van-cell title="物联网" @click="goto('http://62.234.87.48:8088/#/mobile/5f98dceafb07fe7ed613a347')"/>
                <van-cell title="轨道" @click="goto('gd')"/>
                <van-cell title="新能源" @click="goto('xny')"/>
                <van-cell title="旅游" @click="goto('ly')"/>
                <van-cell title="冷链物流加工" @click="goto('ll')"/>
                <van-cell title="快递" @click="goto('kd')"/>
                <van-cell title="养老" @click="goto('mz')"/>
            </van-cell-group>
        </van-popup>
    </div>
</template>

<script>

    import options from "./chartsoption.js";
    import echarts from "echarts";
    import "echarts-wordcloud";
    import 'vant/lib/index.css';
    import { ImagePreview} from 'vant';
    export default {
        name:"pedigreeM",
        props:["type"],
        data() {
            return {
                loading: false,
                showright: false,

                title:"",
                titleEn:"",
                jobpics:[],
                industrypics:[],
                needkeywords:[],

                config_keywordzz: {
                    data: [],
                    rowNum:10,
                    carousel: 'single',
                    valueFormatter:()=>""
                },
                config_keywordgz: {
                    data: [],
                    rowNum:10,
                    carousel: 'single',
                    valueFormatter:()=>""
                },
                config_industrytop10: {
                    data: [],
                    rowNum:'10',
                    carousel: 'single',
                    valueFormatter:()=>""
                },
                config_majortop10: {
                    data: [],
                    rowNum:'10',
                    carousel: 'single',
                    valueFormatter:()=>""
                },
                config_jobneedstop10: {
                    data: [],
                    rowNum:'10',
                    carousel: 'single',
                    valueFormatter:()=>""
                },
                config_jobprovidezztop5: {
                    data: [],
                    rowNum:'5',
                    carousel: 'single',
                    valueFormatter:()=>""
                },
                config_jobprovidegztop5: {
                    data: [],
                    rowNum:'5',
                    carousel: 'single',
                    valueFormatter:()=>""
                },

                chart_industrypos:null,
                chart_majorpos:null,
                chart_needkeywords:null,
                chart_providekeywords:null,
                isActive:false,
                popPics:[],
                popWinStyle:{
                    visibility: 'hidden',
                },
                fmaskShow:false,
            };
        },
        components: {
        },
        mounted(){
            // console.log(this.$refs.dvfullscreencontainer.ready);
            this.init();
        },
        watch:{
            type(){
                this.init();
            }
        },
        methods: {
            async init(){
                this.loading = true;

                const data = await (await fetch(`/pedigreedata/${this.type}/data.json`)).json();
                // console.log(data);

                this.title = data.title;
                this.titleEn = data.titleEn;
                this.jobpics = data.jobpics;
                this.industrypics = data.industrypics;
                const that = this;

                const provincePos = {
                    "东部": ["北京", "天津", "河北", "上海", "江苏", "浙江", "福建", "山东", "广东", "海南", "辽宁", "吉林", "黑龙江"],
                    "中部": ["山西", "安徽", "江西", "河南", "湖北", "湖南"],
                    "西部": ["内蒙古", "广西", "重庆", "四川", "贵州", "云南", "西藏", "陕西", "甘肃", "青海", "宁夏", "新疆"],
                };

                data.industryprovince.sort(valuesort);
                data.majorprovince.sort(valuesort);
                this.config_industrytop10.data = data.industryprovince.slice(0,10);
                this.config_industrytop10 = {...this.config_industrytop10};
                this.config_majortop10.data = data.majorprovince.slice(0,10);
                this.config_majortop10 = {...this.config_majortop10};
                this.config_jobneedstop10.data = data.jobneedstop10;
                this.config_jobneedstop10 = {...this.config_jobneedstop10};
                this.config_jobprovidegztop5.data = data.jobprovidegztop5;
                this.config_jobprovidegztop5 = {...this.config_jobprovidegztop5};
                this.config_jobprovidezztop5.data = data.jobprovidezztop5;
                this.config_jobprovidezztop5 = {...this.config_jobprovidezztop5};
                this.config_keywordgz.data = data.gzprovidekeywords;
                this.config_keywordgz = {...this.config_keywordgz};
                this.config_keywordzz.data = data.zzprovidekeywords;
                this.config_keywordzz = {...this.config_keywordzz};

                if (this.type === "kd") {
                    options["gzgap"].series.splice(0,0, {
                        name: '高中及以下',
                        type: 'bar',
                        label: {
                            show: false,
                            position: 'inside'
                        },
                        barWidth:15,
                        data: [0,0,0],
                    });
                    options["allneed"].series.splice(0,0,{name:"高中及以下", type: 'bar', barWidth :10});
                    options["allprovide"].series.splice(0,0,{name:"高中及以下", type: 'bar', barWidth :10});
                    options["gzgap"].legend.data.splice(0,0, "高中及以下");
                    options["allneed"].legend.data.splice(0,0, "高中及以下");
                    options["allprovide"].legend.data.splice(0,0, "高中及以下");
                }

                for (let i = 1;i<data.allneed[0].length;i++) {
                    options["gzgap"].series[i-1].data = [
                        data.allneed[0][i] - data.allprovide[0][i],
                        data.allneed[1][i] - data.allprovide[1][i],
                        data.allneed[2][i] - data.allprovide[2][i],
                    ];
                }

                // options["gzgap"].series[0].data = [
                //     data.allneed[0][1] - data.allprovide[0][1],
                //     data.allneed[1][1] - data.allprovide[1][1],
                //     data.allneed[2][1] - data.allprovide[2][1],
                // ];
                // options["gzgap"].series[1].data = [
                //     data.allneed[0][2] - data.allprovide[0][2],
                //     data.allneed[1][2] - data.allprovide[1][2],
                //     data.allneed[2][2] - data.allprovide[2][2],
                // ];
                // options["gzgap"].series[2].data = [
                //     data.allneed[0][3] - data.allprovide[0][3],
                //     data.allneed[1][3] - data.allprovide[1][3],
                //     data.allneed[2][3] - data.allprovide[2][3],
                // ];
                options["allgap"].series[0].data = addArr(...options["gzgap"].series.map(v=>v.data));
                options["allgap"].series[1].data = options["allgap"].series[0].data;

                let qk_year_arr = [];
                for(let i = 0; i < data.allneed.length; i++){
                    console.log(data.allneed[i][0]);
                    qk_year_arr[i] = data.allneed[i][0];
                }
                options["allgap"].xAxis[0].data = qk_year_arr;
                options["gzgap"].xAxis[0].data = qk_year_arr;

                data.allneed.forEach(v=>{
                    const l = v.length;
                    const a = v.slice(1);
                    v[l]=a.reduce((t,v)=>t+(v?v:0),0);
                    if (v[l]) {
                        v[l]/=a.reduce((t,v)=>t+(v?1:0),0);
                    }
                });
                data.allprovide.forEach(v=>{
                    const l = v.length;
                    const a = v.slice(1);
                    v[l]=a.reduce((t,v)=>t+(v?v:0),0);
                    if (v[l]) {
                        v[l]/=a.reduce((t,v)=>t+(v?1:0),0);
                    }
                });

                options.allneed.dataset.source=data.allneed;
                options.allprovide.dataset.source=data.allprovide;

                const industrypos = [];
                const majorpos = [];
                for (const pos in provincePos) {
                    industrypos.push({
                        name:pos,
                        value:data.industryprovince.reduce((t,v)=>t+(provincePos[pos].includes(v.name)?v.value:0),0)
                    });
                    majorpos.push({
                        name:pos,
                        value:data.majorprovince.reduce((t,v)=>t+(provincePos[pos].includes(v.name)?v.value:0),0)
                    });
                }
                options.industrypos.series[0].data = industrypos;
                options.majorpos.series[0].data = majorpos;
                options.needkeywords.series[0].data = data.needkeywords;
                this.needkeywords = data.needkeywords;

                const providekeywords = [...data.gzprovidekeywords,...data.zzprovidekeywords];
                providekeywords.sort(valuesort);
                options.providekeywords.series[0].data = providekeywords;

                this.loading = false;
                initEcharts(this);
            },
            showPopUp:function(type){
                if(type == 'gw'){
                    this.popPics = this.jobpics;
                }else if(type == 'zy'){
                    this.popPics = this.industrypics;
                }
                this.fmaskShow = true;
                this.popWinStyle = {
                    visibility: 'visible',
                };
                this.isActive = true;
            },
            hidePopUp:function(){
                this.fmaskShow = false;
                this.popWinStyle = {
                    visibility: 'hidden',
                };
                this.isActive = false;
            },
            onClickRight(){
                this.showright = true;
            },
            imagePreview(pis, index){
                ImagePreview({
                    images: pis.map(v=>`/pedigreedata/${this.type}/${v}`),
                    startPosition: index,
                });
            },
            goto(name){
                if (name.includes("http")) {
                    location.href=name;
                } else {
                    this.$router.push("/pedigreeM/"+name);
                    this.showright = false;
                }
            }
        }
    };

    const initEcharts = async (vue)=> {
        // console.log(document.getElementById('chart_industry'));
        // await waitfor(()=>vue.$refs.dvfullscreencontainer.ready, 10, 0);
        vue.chart_allgap = echarts.init(document.getElementById('chart_allgap'));
        vue.chart_allgap.setOption(options.allgap);
        vue.chart_gzgap = echarts.init(document.getElementById('chart_gzgap'));
        vue.chart_gzgap.setOption(options.gzgap);

        vue.chart_allneed = echarts.init(document.getElementById('chart_allneed'));
        vue.chart_allneed.setOption(options.allneed);
        vue.chart_allprovide = echarts.init(document.getElementById('chart_allprovide'));
        vue.chart_allprovide.setOption(options.allprovide);
        vue.chart_industrypos = echarts.init(document.getElementById('chart_industrypos'));
        vue.chart_industrypos.setOption(options.industrypos);
        vue.chart_majorpos = echarts.init(document.getElementById('chart_majorpos'));
        vue.chart_majorpos.setOption(options.majorpos);
        vue.chart_needkeywords = echarts.init(document.getElementById('chart_needkeywords'));
        vue.chart_needkeywords.setOption(options.needkeywords);
        vue.chart_providekeywords = echarts.init(document.getElementById('chart_providekeywords'));
        vue.chart_providekeywords.setOption(options.providekeywords);
    };

    // const setDataBarAndLine = (option, data)=>{
    //     const cntarr = data.map(v=>v.cnt);
    //     const payarr = data.map(v=>v.payavg);
    //     option.series[0].data = cntarr;
    //     option.series[1].data = payarr;
    //     option.xAxis[0].data = data.map(v=>v.name);
    //     option.yAxis[0].max = maxRoundnum(cntarr);
    //     option.yAxis[1].max = maxRoundnum(payarr);
    // };

    const setGap = (data, name)=>{
        data[name].provide = data[name].provide.map(v=>-v);
        data[name].gap = data[name].need.map((v,i)=>v+data[name].provide[i]);
        options[name].series[0].data = data[name].gap;
        options[name].series[1].data = data[name].provide;
        options[name].series[2].data = data[name].need;
    };

    const valuesort = (v1,v2)=>v2.value-v1.value;

    const addArr = (arr1,...arrn)=>{
        const arr = [];
        arr1.forEach((v,i)=>{
            arrn.forEach(arr=>{
                v+=arr[i];
            });
            arr.push(v);
        });
        return arr;
    };

    /**
     * 数字保留最高位
     */
    const roundnum = (n) => {
        const p = Math.pow(10, (n + "").length - 2);
        return (parseInt(n/p)) * p;
    };

    /**
     * 数组最大值保留最高位
     */
    const maxRoundnum = (arr) => roundnum(Math.max(...arr));

    /**
     * 学历排序
     * @type {string[]}
     */
    const eduIndexes = ["初中","中专","大专","本科","硕士","博士"];

    const sleep = (timeountMS) => new Promise((resolve) => {
        setTimeout(resolve, timeountMS);
    });
    const waitfor = async (f,max,i)=>{
        if (!f()) {
            await sleep(100);
            await waitfor(f,max,i+1);
        }
    };
</script>

<style scoped>
    .pedigreemobile{width: 100%;height:100%;background:#060a13;padding: 0;margin: 0;}
    .nav-bar div{background: #000;}
    .van-popup .van-nav-bar{background: #000;}
    .title{width:100%;background: #1989fa; color:#fff;font-size:1.2rem;text-align: center;padding: 2.0rem 0;}
    .chartPart{ width:100%;height:5rem;}
    .dv-scroll-ranking-board{
        margin-left: 10px;
    }
    .tags{margin-left: 10px;width:90%}
    .tags .van-tag{margin:10px;}
    .van-swipe-item img {width:100%;}

    .pedigreemobile /deep/ .van-ellipsis{
        color: #fff !important;
    }
    .pedigreemobile /deep/ .van-nav-bar__text{
        color: #fff !important;
    }
</style>
